import { render, staticRenderFns } from "./nutritionDetail.html?vue&type=template&id=72f0a1fc&scoped=true&"
import script from "./nutritionDetail.js?vue&type=script&lang=js&"
export * from "./nutritionDetail.js?vue&type=script&lang=js&"
import style0 from "./nutritionDetail.scss?vue&type=style&index=0&id=72f0a1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f0a1fc",
  null
  
)

export default component.exports